import {AuthContext} from "../../Context/Auth/AuthContext";
import { useContext } from 'react'

export const useAuthContext = () => {
    const context = useContext(AuthContext)

    if (!context) {
        throw Error('useAuthContext must be used inside an WorkoutsContextProvider')
    }

    return context
}